import React from "react";
import { bankLines, hoursLines, hoursTitle, statLabel } from "@/lib/stationery";

// Briefpapier-voettekst: klein en grijs, in de taal van het document.
export default function PrintFooter({ camp = {}, lang = "nl", note = "", vatLabel = "" }) {
  const bank = bankLines(camp);
  const hours = hoursLines(camp, lang);
  const addr = [camp.camp_name, camp.street, [camp.postal_city, camp.country].filter(Boolean).join(" ")].filter(Boolean);
  return (
    <div className="mt-8 border-t border-slate-300 pt-2 grid grid-cols-3 gap-4 text-[8px] leading-snug text-slate-500 break-inside-avoid" data-testid="print-footer">
      <div data-testid="print-footer-camp">
        {addr.map((l) => <p key={l}>{l}</p>)}
        {camp.vat_number && <p>{vatLabel ? `${vatLabel}: ` : ""}{camp.vat_number}</p>}
        {camp.footer_extra && <p>{camp.footer_extra}</p>}
        {note && <p className="italic">{note}</p>}
      </div>
      <div data-testid="print-footer-bank">
        {bank.length > 0 && <p className="font-semibold text-slate-600">{statLabel(lang, "bank")}</p>}
        {bank.map((l) => <p key={l}>{l}</p>)}
      </div>
      <div data-testid="print-footer-hours">
        {hours.length > 0 && <p className="font-semibold text-slate-600">{hoursTitle(camp, lang)}</p>}
        {hours.map((l) => <p key={l}>{l}</p>)}
      </div>
    </div>
  );
}
